export default class ExportTranslationCacheName {
  static getTranslationDetails(): string {
    return "translationDetails";
  }
}
